import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { cleanLoginInfo, getToken } from "./auth";
import tooles from "./tools/format";
import { messageError, messageWarning } from './message';

const BASE_URL = "https://eulqh6d3kl.execute-api.us-west-2.amazonaws.com/prod/";
// const BASE_URL = "https://i7yruzk2y5.execute-api.us-west-2.amazonaws.com/dev/"

// create an axios instance
const service: AxiosInstance = axios.create({
    baseURL: BASE_URL, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 50000 // request timeout
});

interface RequestConfig extends AxiosRequestConfig {
    params?: { [key: string]: any };
    data?: { [key: string]: any };
}

// request interceptor
service.interceptors.request.use(
    (config: RequestConfig) => {
        // do something before request is sent
        if (config.headers) {
            config.headers['Authorization'] = getToken();
        }
        return config;
    },
    (error) => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

// 请求参数处理
service.interceptors.request.use((request: RequestConfig) => {
    if (request.params) { // get请求参数
        let temdata = JSON.parse(JSON.stringify(request.params)); // 防止深拷贝跟浅拷贝
        tooles.jsonNewLineData(temdata);
        request.params = temdata;
    }
    if (request.data) { // post请求参数
        let temdata = JSON.parse(JSON.stringify(request.data)); // 防止深拷贝跟浅拷贝
        tooles.jsonNewLineData(temdata);
        request.data = temdata;
    }
    return request;
}, (error) => {
    return Promise.reject(error);
});

// 错误处理
service.interceptors.response.use((resp: AxiosResponse) => {
    return resp;
}, (err) => {
    if (err.response) {
        const status = err.response.status;
        if (status === 400) {
            messageWarning("参数错误！");
        } else if (status === 401) {
            messageWarning("token失效，请重新登陆！！！");
            cleanLoginInfo();
            location.reload();
        } else if (status === 403) {
            messageWarning("权限不足，不能访问该页面");
        } else if (status === 500) {
            console.log("服务器错误");
            messageError("服务器错误！！！");
        } else {
            console.log("请求失败");
            console.log(err);
            messageError("请求失败！");
        }
    }
    return Promise.reject(err);
});

// 返回参数处理
service.interceptors.response.use((resp: AxiosResponse) => {  // 该处为后端返回整个内容
    tooles.jsonNewDate(resp.data);
    return resp;
}, (error) => {
    return Promise.reject(error);
});

export default service;